module.exports = __webpack_public_path__ + "static/media/illuminate-2.f25f586d.png";